import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { UtilisateurLightDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurLightDto";
import { CompteApplicationLightDto } from "../../dto/GenApi.iNotPaie.Dto/CompteApplicationLightDto";
import ModalUtilisateurs from "./modalUtilisateurs/modalUtilisateurs";
import * as $ from "jquery";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { UtilisateurSSORolesTalent } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurSSORolesTalent";

@Component({
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as UtilisateursComponent);
			vm.Init();
		});
	},
	components: {
		ModalUtilisateurs: require("./modalUtilisateurs/modalUtilisateurs.vue.html")
	}
})
export default class UtilisateursComponent extends Vue {
    public utilisateurs: UtilisateurSSORolesTalent[] = [];
    public utilisateursFiltred: UtilisateurSSORolesTalent[] = [];
	public dataReady = false;
	public currentOrderColumn = "Login";
	public orderingDesc = true;
	public filterName = "";
	public modalUtilisateurs?: ModalUtilisateurs = undefined;

	public Init(): void {
        ServicesFactoryInstance.UtilisateursService.getUtilisateursWithRolesTalent(data => {
    		this.utilisateurs = data;

    		for (let i = 0; i < this.utilisateurs.length - 1; i++) {
    			const u: any = this.utilisateurs[i];
    			u.selectedCodeFamille = "INOTPAIE";
    		}

    		this.utilisateursFiltred = data;
    		this.doFilter();
    		this.getClassOfOrder(this.currentOrderColumn, true);
    		this.dataReady = true;
    	});
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public oderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public getComptes(comptes: CompteApplicationLightDto[]): string {
    	let libelle = "";
    	for (let i = 0; i < comptes.length; i++) {
    		libelle += comptes[i].Application + " / " + comptes[i].Login;
    		if (i != comptes.length - 1) {
				libelle += ", ";
			}
    	}

    	return libelle;
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.utilisateursFiltred != undefined) {
    		this.utilisateursFiltred = this.utilisateursFiltred.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public doFilter(): void {
    	this.utilisateursFiltred = this.utilisateurs.filter(s =>
    		(s.Id != undefined && s.Id.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.IdProfil != undefined && s.IdProfil.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.Email != undefined && s.Email.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.Telephone != undefined && s.Telephone.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.IdUtilisateur != undefined && s.IdUtilisateur.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.Nom != undefined && s.Nom.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.Prenom != undefined && s.Prenom.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
            (s.Login != undefined && s.Login.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0));
    	this.doOrder();
	}

    public update(user: UtilisateurSSORolesTalent): void {
    	if (this.modalUtilisateurs == undefined) {
			this.modalUtilisateurs = this.$refs.modalUtilisateurs as ModalUtilisateurs;
		}

    	if (this.modalUtilisateurs == undefined) {
			return;
		}

        this.modalUtilisateurs.Init(user.IdUtilisateur);
    	$("#modalUtilisateurs").modal("show");
	}

	public add(): void {
    	if (this.modalUtilisateurs == undefined) {
			this.modalUtilisateurs = this.$refs.modalUtilisateurs as ModalUtilisateurs;
		}

    	if (this.modalUtilisateurs == undefined) {
			return;
		}

    	this.modalUtilisateurs.Init();
    	$("#modalUtilisateurs").modal("show");
	}
}



// WEBPACK FOOTER //
// ./src/components/utilisateurs/utilisateurs.ts